import React from 'react'
import { Color } from '../utils/constants'
import { twMerge } from 'tailwind-merge'

interface TagProps {
  title: string
  color: Color
}

const Tag = ({ title, color }: TagProps) => {
    return (
        <div
            className={twMerge(
                'w-max px-3 py-1.5 rounded-full border border-black/10 transition',
                color === Color.WHITE ? 'bg-white/20' : 'bg-black/10',
            )}
        >
            <p className='text-xs opacity-100'>{title}</p>
        </div>
    )
}

export default Tag
